import './meddeli2/style';
import FormStructure from './meddeli2/form_structure';

export default FormStructure;